import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import { fireGTM } from '../../gtm/gtmUtil';
import {
  login_GTM,
  logout_GTM,
} from '../../gtm/datalayers/utilDataLayers.json';

const loginButtonStyles = {
  color: (props) => ({
    backgroundColor: props.backgroundColor ? props.backgroundColor : 'white',
    border: `1px solid ${props.color}`,
    color: props.color,
    borderStyle: 'solid',

    '&:hover': {
      backgroundColor: props.color,
      borderColor: props.color,
      color: 'white',
    },
  }),
};

class LoginButton extends Component {
  keyDowngoToLoginPage = (e) => {
    if (['Enter'].includes(e.key)) {
      this.goToLoginPage();
    }
  };

  goToLoginPage = () => {
    fireGTM(login_GTM, 'Log in', this.props.section);
    this.props.history.push(`/${this.props.tenant.name.toLowerCase()}/login`);
  };

  logout = async () => {
    try {
      fireGTM(logout_GTM, 'Log out', this.props.section);
      await Auth.signOut({ global: true });
    } catch (error) {
      console.error('could not log out: ', error.message);
    }
  };

  render() {
    return (
      <Translation>
        {(t) =>
          this.props.isAuthenticated ? (
            <button
              className={[
                'button--primary',
                'login-button',
                // this.props.classes.color,
                this.props.additionalClassNames,
              ].join(' ')}
              style={{
                backgroundColor: 'white',
                border: `2px solid ${this.props.color}`,
                color: this.props.color,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = this.props.color;
                e.currentTarget.style.border = `2px solid ${this.props.color}`;
                e.currentTarget.style.color = 'white';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = this.props.color;
              }}
              type="button"
              onClick={this.logout}
              onKeyDown={this.keyDownLogout}
            >
              {t('Log out')}
            </button>
          ) : (
            <button
              className={[
                // this.props.overRideStyle,
                'button--primary',
                'login-button',
                // this.props.classes.color,
              ].join(' ')}
              style={{
                backgroundColor: 'white',
                border: `2px solid ${this.props.color}`,
                color: this.props.color,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = this.props.color;
                e.currentTarget.style.border = `2px solid ${this.props.color}`;
                e.currentTarget.style.color = 'white';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = this.props.color;
              }}
              onClick={this.goToLoginPage}
              onKeyDown={this.keyDownGoToLoginPage}
              id="submit"
              type="button"
            >
              {t('Log in')}
            </button>
          )
        }
      </Translation>
    );
  }
}

export default withStyles(loginButtonStyles)(withRouter(LoginButton));

LoginButton.propTypes = {
  color: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  tenant: PropTypes.object.isRequired,
};
